function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#33CCFF",
  d: "M150,0C67.159,0,0.002,67.159,0.002,150c0,82.838,67.157,150.005,149.997,150.005S300.003,232.841,300.003,150 C300,67.159,232.841,0,150,0z M235.661,168.822c-6.756,42.93-43.939,73.662-86.101,73.662c-4.487,0-9.028-0.35-13.598-1.066 c-47.497-7.485-80.063-52.215-72.593-99.707c3.621-23.011,15.985-43.236,34.814-56.946c16.21-11.801,35.538-17.543,55.286-16.607 l-14.527-13.834l9.521-9.991l22.29,21.239l0.005-0.003l9.97,9.513l-9.513,9.991l-0.005-0.008l-21.237,22.295l-9.98-9.521 l13.456-14.112c-16.457-0.934-32.605,3.789-46.107,13.619c-15.471,11.264-25.628,27.879-28.603,46.784 c-6.134,39.019,20.622,75.768,59.643,81.915c39.019,6.131,75.765-20.617,81.904-59.641c4.054-25.76-6.225-51.72-26.834-67.751 l9.56-12.281C228.083,105.877,240.595,137.47,235.661,168.822z M121.096,175.443l-0.511-1.196l12.823-5.436l0.506,1.198 c2.039,4.84,9.088,8.489,16.394,8.489c3.284,0,13.995-0.599,13.995-8.339c0-4.054-4.58-6.481-14.415-7.641 c-11.036-1.237-26.162-2.928-26.162-19.587c0-10.214,7.641-17.354,20.508-19.255v-7.851h13.821v7.885 c5.973,1.05,13.855,3.652,18.251,12.644l0.584,1.19l-11.804,5.46l-0.597-0.993c-2.067-3.413-8.147-6.092-13.834-6.092 c-3.836,0-12.755,0.685-12.755,7.011c0,4.547,5.747,5.594,13.264,6.494c11.752,1.447,27.84,3.429,27.84,20.733 c0,12.735-10.328,19.439-20.946,20.627v8.953H144.24v-8.523C133.09,189.903,124.893,184.329,121.096,175.443z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "98px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.005 300.005",
    style: {
      enableBackground: "new 0 0 300.005 300.005"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.2ca72321.svg";
export { ForwardRef as ReactComponent };